import { unwrapSec } from '@root/components/SquadBet/helper'
import I18n from 'i18n-js'
import React from 'react'

const BetStatusShortCountdown: React.FC<{segments: ReturnType<typeof unwrapSec>}> = ({ segments }) => {
  const { d, hh, mm, ss, numbers } = segments

  const mode = numbers.totalSec > 60 * 60 * 8
    ? 'daysHoursMinutes'
    : 'hoursMinutesSeconds'

  return <span className={`shortCdwn shortCdwn--${mode}`}>
    {mode === 'daysHoursMinutes'
      ? <>{/* _D __S __M*/}
          {numbers.d > 0 &&
            <span className="shortCdwn__segment shortCdwn__segment--d">
              <strong>{d}</strong>
              <span>{I18n.t("general.countdown_supershort_days")}</span>
            </span>}
            <span className="shortCdwn__segment shortCdwn__segment--h">
              <strong>{hh}</strong>
              <span>{I18n.t("general.countdown_supershort_hours")}</span>
            </span>
            <span className="shortCdwn__segment shortCdwn__segment--m">
              <strong>{mm}</strong>
              <span>{I18n.t("general.countdown_supershort_minutes")}</span>
            </span>
        </>
      : <>{/* 00:00 */}
          <span className="shortCdwn__hhmmss">
            <strong>{hh}</strong>
            <span>{':'}</span>
            <strong>{mm}</strong>
            <span>{':'}</span>
            <strong>{ss}</strong>
          </span>
        </>}
  </span>
}

export default BetStatusShortCountdown
